import { render, staticRenderFns } from "./SsoAuth.vue?vue&type=template&id=00d70888&scoped=true&"
import script from "./SsoAuth.vue?vue&type=script&lang=ts&"
export * from "./SsoAuth.vue?vue&type=script&lang=ts&"
import style0 from "./SsoAuth.vue?vue&type=style&index=0&id=00d70888&prod&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d70888",
  null
  
)

export default component.exports